import { selectorFamily } from 'recoil';

import { getRegionsRequest } from 'requests/regions';
import { withSilentError } from 'utils/request';
import { byKey } from 'utils/data';

export const selectRegions = selectorFamily({
  key: 'regions',
  get:
    ({ productId = null, analog = false }) =>
    () =>
      withSilentError(getRegionsRequest(productId, analog), []).then(items => {
        const { dict: byId, keys } = byKey(items);
        return { byId, keys, items };
      }),
});
